import * as React from "react";

import {IWSMUSummaryTableProps, WSMUSummaryTable} from "./WSMUSummaryTable";

export enum SelectType {
    SingleSelect = 0,
    SelectAll = 1,
    DeselectAll = 2
}

export const getValidItemsTab = (props: IWSMUSummaryTableProps) => {
    return ({
        menuItem: {
            key: 'valid-tab',
            className: 'valid-tab',
            content: (
                <b style={{color: 'green'}}>{props.t("PSL_WF_S_MULTI:VALID_ITEMS_TAB")}</b>
            )
        },
        render: () => <WSMUSummaryTable {...props}/>
    });
};

export const getInvalidItemsTab = (props: IWSMUSummaryTableProps, disclaimer: string) => {
    return ({
        menuItem: {
            key: 'invalid-tab',
            className: 'invalid-tab',
            content: (
                <b style={{color: 'red'}}>{props.t("PSL_WF_S_MULTI:INVALID_ITEMS_TAB")}</b>
            )
        },
        render: () => {
            return (
                <>
                    <div style={{marginBottom: '20px'}}>{disclaimer}</div>
                    {<WSMUSummaryTable {...props}/>}
                </>
            );
        }
    });
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/workflowStatusMultiUpdate/WSMUSummaryUtils.tsx